import React from "react";
import PrizeTableFilter from "./PrizeTableFilter";

const PrizeTableFilterContainer: React.FC = () => {
  return <PrizeTableFilter />;
};

export default PrizeTableFilterContainer;
